import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { NamedLink, Logo } from '../../components';

import css from './SectionGiftCard.module.css';

const SectionGiftCard = props => {
  const { rootClassName, className } = props;

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <div className={css.content}>
        <span className={css.eyebrow}>
          <FormattedMessage id="SectionGiftCard.eyebrow" defaultMessage="The perfect gift" />
        </span>
        <h2 className={css.title}>
          <FormattedMessage id="SectionGiftCard.title" defaultMessage="Give the Gift of Adventure" />
        </h2>
        
        <div className={css.grid}>
          <div className={css.textColumn}>
            <p className={css.description}>
              <FormattedMessage 
                id="SectionGiftCard.description" 
                defaultMessage="Looking for the perfect present? Crion Gift Cards unlock thousands of outdoor experiences. Valid for 1 year and delivered instantly via email." 
              />
            </p>
            <ul className={css.benefitList}>
              <li>
                <FormattedMessage
                  id="SectionGiftCard.benefitCredit"
                  defaultMessage="Digital credit for outdoor experiences with local professionals."
                />
              </li>
              <li>
                <FormattedMessage
                  id="SectionGiftCard.benefitAmount"
                  defaultMessage="Choose CHF or EUR, fixed values, or a custom amount."
                />
              </li>
              <li>
                <FormattedMessage
                  id="SectionGiftCard.benefitDelivery"
                  defaultMessage="Send it to yourself or directly to the recipient with a personal message."
                />
              </li>
            </ul>
            <NamedLink name="GiftCardPage" className={css.ctaButton}>
              <FormattedMessage id="SectionGiftCard.ctaButton" defaultMessage="Buy Gift Card" />
            </NamedLink>
          </div>

          <div className={css.cardPreview}>
            <div className={css.cardPattern}></div>
            <div className={css.cardHeader}>
              <Logo className={css.logo} format="desktop" />
            </div>
            <div className={css.cardBody}>
              <div className={css.cardTitle}>
                <FormattedMessage id="SectionGiftCard.cardTitle" defaultMessage="Gift Card" />
              </div>
              <div className={css.cardSubtitle}>
                <FormattedMessage id="SectionGiftCard.cardSubtitle" defaultMessage="Value of your choice" />
              </div>
            </div>
            <div className={css.cardFooter}>
              <span className={css.cardText}>
                crion.org
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SectionGiftCard.defaultProps = {
  rootClassName: null,
  className: null,
};

SectionGiftCard.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionGiftCard;
